import axios from "axios";
import { apiUrl, config } from '../../../config.js';

async function disconnectWSAPI (token, reason) {
  try { await axios.post(`${apiUrl}/session/logout`, null, {...config, params: { token, reason }}) }
  catch (error) { return false }

  return true
}

export { disconnectWSAPI }
